// Threat-model findings types — wire shape from
// src/ai_alm/api/routes/threat_model_findings.py.

export type ThreatModelFindingKind =
  | 'missing_mandatory_asset'
  | 'missing_stride_category'
  | 'no_asset_sections'

export type ThreatModelFindingSeverity = 'critical' | 'high' | 'medium'

export interface ThreatModelFindingRow {
  finding_kind: ThreatModelFindingKind
  severity: ThreatModelFindingSeverity
  rule_source: string
  message: string
  cites: string[]
  asset_name: string | null
  stride_category: string | null
  suggested_fix: string | null
  /** Stable identity echoed back to the finding-waivers route. */
  finding_key: string
  /** True when an unexpired waiver already accepts this finding. */
  waived: boolean
  /** Accepted-waiver justification, when waived. */
  waiver_justification: string | null
}

/** PEG invariant id this panel's findings belong to. */
export const TM_INVARIANT_ID = 'PEG-THREAT-MODEL-COMPLETENESS-001'

export interface ThreatModelFindingsResponse {
  findings: ThreatModelFindingRow[]
  asset_inventory: string[]
  regulatory: string[]
  shape: string | null
  threat_model_present: boolean
}

// UI palette — severity → chip class
export const TM_SEVERITY_PALETTE: Record<
  ThreatModelFindingSeverity,
  { label: string; chipClass: string }
> = {
  critical: {
    label: 'Critical',
    chipClass: 'bg-red-950/40 border-red-700/50 text-red-200',
  },
  high: {
    label: 'High',
    chipClass: 'bg-amber-950/40 border-amber-700/50 text-amber-200',
  },
  medium: {
    label: 'Medium',
    chipClass: 'bg-sky-950/40 border-sky-700/50 text-sky-200',
  },
}

// UI palette — finding-kind → human label
export const TM_KIND_LABEL: Record<ThreatModelFindingKind, string> = {
  missing_mandatory_asset: 'Missing required asset',
  missing_stride_category: 'Missing STRIDE category',
  no_asset_sections: 'No asset sections',
}
